module.exports = __webpack_public_path__ + "img/big-wrench.11533b5b.svg";